import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  overlayContainer: {
    '& > div:first-of-type': {
      background: colors.gray,
      color: colors.white,
    },
    '& > div:last-of-type::after': {
      display: 'none',
    },
  },
});

export default useStyles;
